export class ReportDate {
    private _companyCode: string;
    private _companyName: string;
    private _timestamp?: Date;

    constructor(companyCode: string, companyName: string, timestamp: Date | undefined) {
        this._companyCode = companyCode;
        this._companyName = companyName;
        this._timestamp = timestamp;
    }

    get companyCode() {
        return this._companyCode;
    }

    get companyName() {
        return this._companyName;
    }

    get timestamp() {
        return this._timestamp;
    }
}
